var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#467A3C",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 9.831,
    x: 4.6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.916c0-.266.216-.482.482-.482h9.236a.482.482 0 1 1 0 .964H.482A.482.482 0 0 1 0 4.916z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhiteIcon);
export default __webpack_public_path__ + "static/media/add-white-icon.d059fe14269cba8f50f25f35056df9a7.svg";
export { ForwardRef as ReactComponent };